import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';
import { EditableProps } from './EditableProps';

export const Editable: FunctionComponent<PropsWithChildren<EditableProps>> = ({ children, className, onDelete }) => {
  return (
    <div className={classNames('relative z-0', className)}>
      <button
        className="absolute z-10 w-6 h-6 hover-effect click-effect"
        style={{ top: '-8px', right: '-8px' }}
        onClick={onDelete}
      >
        <img src="/images/icons/delete_red.svg" />
      </button>
      {children}
    </div>
  );
};
